"use strict";
$(document).ready(function() {
  var $js_menu_mobile = $('.js-menu-mobile');

  $js_menu_mobile.click(function(e) {
    e.preventDefault();
    $('body').addClass("menuMobileActive");
  });

  // function faq
  // $element : element detect faq
  // $affect : element affect for add class "is-show"
  // $area_limit_item: area limit outside each element item
  // $area_limit: area limit outside of $element
  function js_faq($element, $affect, $area_limit_item, $area_limit) {
    var $element = '.js-faq', $affect = '.is-affect-faq', $area_limit_item = '.is-faq-item', $area_limit = '.area-limit-faq';
    var $jsfaq = $($element);
    if($jsfaq.length) {
      $jsfaq.click(function (e) {
        if($(this).hasClass('active')) {
          $(this).closest($area_limit_item).find($affect).slideUp();
          $(this).closest($area_limit).find($jsfaq).removeClass('active');
          $(this).closest($area_limit).find($area_limit_item).removeClass('active');
        } else {
          $(this).closest($area_limit).find($affect).slideUp();
          $(this).closest($area_limit_item).find($affect).first().slideDown();
          $(this).closest($area_limit).find($jsfaq).removeClass('active');
          $(this).closest($area_limit).find($area_limit_item).removeClass('active');
          $(this).addClass('active');
          $(this).closest($area_limit_item).addClass('active');
        }
      });
    }
  }

  setTimeout(() => {
    $(window).scroll(function() {
       var pos = $(window).scrollTop();
       var announcementBar = document.getElementById("shopify-section-announcement_bar");
      var announcementHeight = $(announcementBar).height();
  
       $('.cpn-header').removeClass('fixed-header');
       $('.snize-ac-results-mobile').removeClass('fixed-search');
       var scroll = $(window).scrollTop();
       if( pos >= announcementHeight ){
        $('.cpn-header').addClass('fixed-header');
        $('.snize-ac-results-mobile').addClass('fixed-search');
      }else {
        $('.cpn-header').removeClass('fixed-header');
        $('.snize-ac-results-mobile').removeClass('fixed-search');
      }
    });
  });

  js_faq();
  //search bar (add class to ul)
  // $(document).on('change paste keyup', function() {
  //   if (!$("#snize-mobile-search-input").val()) {
  //     $('.snize-ac-results.snize-ac-results-mobile > ul').removeClass('js-results-show');
  //   } else {
  //     $('.snize-ac-results.snize-ac-results-mobile > ul').addClass('js-results-show');
  //   }
  // });

  // $('#snize-mobile-search-input').on('input', () => {
  //   if (!$("#snize-mobile-search-input").val()) {
  //     $('.snize-ac-results.snize-ac-results-mobile ul').removeClass('js-results-show');
  //   } else {
  //     $('.snize-ac-results.snize-ac-results-mobile ul').addClass('js-results-show');
  //   }
  // })

  // // detect browser safari on search bar
  // var ua = navigator.userAgent.toLowerCase(); 
  // if (ua.indexOf('safari') != -1) { 
  //   if (ua.indexOf('safari') < -1) {
  //     alert("safari browser");
  //   }
  // }
  // //unscroll
  
  //   $('.jsDrawerOpenRight').click(function(){
  //     $('body').addClass('unscroll');
  //     $('.cart_block').addClass('open');
  //   })

  //   $(document).mouseup(function(e) 
  //   {
  //       var container = $(".js-cpn-header__car");
  //       if (!container.is(e.target) && container.has(e.target).length === 0) 
  //       {
  //         $('body').removeClass('unscroll');
  //         $('.cart_block').removeClass('open');
  //       }
  //   });

  //Currency Converter
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }
  
  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  $('.cpn-header__currency option[value=CHF]').text('CHF');
});
